export default "__VITE_ASSET__6VlrvNZO__"